import {AXIOS, AXIOSunsecure} from "@/common/http-common";
import ModelGlobalMessage from "@/components/module/shared/ModelGlobalMessage";
import LoadingModal from "@/components/module/shared/LoadingModal";


export const modelHttpMixin = {

  data() {
    return {
      isLoading: false,
      isSubmitted: false,
      // Keep local arrays for backward-compat with ModelGlobalMessage prop bindings
      globalErrors: [],
      message: null,
      warning: null
    }
  },
  components: {
    ModelGlobalMessage, LoadingModal
  },
  methods: {
    clearMessages() {
      this.globalErrors.splice(0);
      this.message = '';
      this.warning = '';
      this.isLoading = false;
      this.isSubmitted = false;
    },
    getData(url, fn) {
      this.isLoading = true;
      AXIOS().get(url)
        .then(response => {
          this.isLoading = false;
          fn(response.data);
        })
        .catch(e => {
          this.catchError(e);
        })
    },
    delete(url, fn) {
      this.isLoading = true;
      AXIOS().delete(url)
        .then(response => {
          this.isLoading = false;
          fn(response.data);
        })
        .catch(e => {
          this.catchError(e);
        })
    },
    getUnSecureData(url, fn) {
      this.isLoading = true;
      AXIOSunsecure().get(url)
        .then(response => {
          this.isLoading = false;
          fn(response.data);
        })
        .catch(e => {
          this.catchError(e);
        })
    },
    postUnsecureData(url, putData, fn) {
      this.isLoading = true;
      AXIOSunsecure().post(url, putData)
        .then(response => {
          this.isLoading = false;
          fn(response.data);
        })
        .catch(e => {
          this.catchError(e);
        })
    },

    postData(url, postData, fn, errorFn) {
      this.isLoading = true;
      AXIOS().post(url, postData)
        .then(response => {
          this.isLoading = false;
          fn(response.data);
        })
        .catch(e => {
          this.catchError(e, errorFn);
        })
    },
    patchData(url, postData, fn) {
      this.isLoading = true;
      AXIOS().patch(url, postData)
        .then(response => {
          this.isLoading = false;
          fn(response.data);
        })
        .catch(e => {
          this.catchError(e);
        })
    },
    putData(url, putData, fn) {
      this.isLoading = true;
      AXIOS().put(url, putData)
        .then(response => {
          this.isLoading = false;
          fn(response.data);
        })
        .catch(e => {
          this.catchError(e);
        })
    },
    _dispatchGlobalError(msg) {
      // Route errors through Vuex so App.vue global Toast fires
      if (this.$store) {
        this.$store.dispatch('pushGlobalError', msg);
      }
    },
    catchError(error, errorFn) {
      this.isLoading = false;
      if (error.response) {
        if (error.response.status === 401) {
          localStorage.clear();
          window.sessionStorage.clear();
          this.$router.replace({name: 'HomePage'});
          return;
        }
        if (error.response.data && error.response.data.error) {
          this._dispatchGlobalError(error.response.data.error);
        } else if (error.response.data && error.response.data.allErrors && error.response.data.allErrors.length > 0) {
          error.response.data.allErrors.forEach(err => {
            this._dispatchGlobalError(err.code || err.defaultMessage || JSON.stringify(err));
          });
        } else if (error.response.data && error.response.data.message) {
          this._dispatchGlobalError(error.response.data.message);
        } else {
          this._dispatchGlobalError('An error occurred. Please try again.');
        }
      } else if (error.request) {
        this._dispatchGlobalError('Network.Error');
      } else {
        if (error.message) {
          this._dispatchGlobalError(error.message);
        }
      }
      if (errorFn) {
        errorFn();
      }
    },
    pushGlobalError(error) {
      this._dispatchGlobalError(error);
    }
  }

}
